/**
 * The only gate and the only rollback for Public Grid. There is no
 * `public_grid` item definition to enable, so `enabledItemDefOfKind` plays no
 * part — turning this off is what hides the flow.
 *
 * Lives here rather than beside the card maker so that `useDataForCards` and
 * the eligibility hook can read it without importing from `flows/core`, which
 * would close an import cycle back through `DataForCards`.
 */
export const PUBLIC_GRID_FEATURE_FLAG = 'consumer_app_public_grid';
